import React from "react";
import {StagePlanItemAppeal} from "./appeal/stage-plan-item";
import {StagePlanItemDefault} from "./default/stage-plan-item";
import {StagePlanItemI, StagePlanItemType} from "../../model/types/types";
import {StagePlanItemOrder} from "./order/stage-plan-item";

export interface StagePlanItemWithTypeI extends StagePlanItemI{
    typeItem?: StagePlanItemType
}
export const StagePlanItem: React.FC<StagePlanItemWithTypeI>  = (props: StagePlanItemWithTypeI) => {
    const {typeItem, ...otherProps} = props;

    switch (typeItem) {
        case 'appeal':
            return <StagePlanItemAppeal {...otherProps}/>
        case 'order':
            return <StagePlanItemOrder {...otherProps}/>
        default:
            return <StagePlanItemDefault {...otherProps}/>
    }
}
